import { posthog } from './posthog.client';

export function trackEvent(name: string, properties?: Record<string, unknown>) {
  posthog.capture(name, properties);
}
